const color_cosmetics = [
  {
    image: '/img/capsules/color_cosmetics/fountainLab-100.png',
    name: "FountainLab",
    volume: 100
  },
  {
    image: '/img/capsules/color_cosmetics/multiLab-60.png',
    name: 'MultiLab',
    volume: 60
  },
  {
    image: '/img/capsules/color_cosmetics/fountainLab-200.png',
    name: "FountainLab",
    volume: 200
  },
  {
    image: '/img/capsules/color_cosmetics/ovalLab-80.png',
    name: "OvalLab",
    volume: 80
  }
]

const hair = [
  {
    image: '/img/capsules/hair/fountainLab-100.png',
    name: "FountainLab",
    volume: 100
  },
  {
    image: '/img/capsules/hair/ovalLab-80.png',
    name: "OvalLab",
    volume: 80
  },
  {
    image: '/img/capsules/hair/fountainLab-200.png',
    name: "FountainLab",
    volume: 200
  },
  {
    image: '/img/capsules/hair/ovalLab-150.png',
    name: "OvalLab",
    volume: 150
  }
]

const skincare = [
  {
    image: '/img/capsules/skincare/multiLab-25.png',
    name: 'MultiLab',
    volume: 25
  },
  {
    image: '/img/capsules/skincare/singleLab-15.png',
    name: 'SingleLab',
    volume: 15
  },
  {
    image: '/img/capsules/skincare/multiLab-60.png',
    name: 'MultiLab',
    volume: 60
  },
  {
    image: '/img/capsules/skincare/singleLab-15.png',
    name: 'SingleLab',
    volume: 25
  }
]

const superfood = [
  {
    image: '/img/capsules/superfood/fountainLab-100.png',
    name: "FountainLab",
    volume: 100
  },
  {
    image: '/img/capsules/superfood/ovalLab-80.png',
    name: "OvalLab",
    volume: 80
  },
  {
    image: '/img/capsules/superfood/fountainLab-300.png',
    name: "FountainLab",
    volume: 300
  },
  {
    image: '/img/capsules/superfood/ovalLab-40.png',
    name: "OvalLab",
    volume: 40
  }
]

const supplements = [
  {
    image: '/img/capsules/supplements/fountainLab-100.png',
    name: "FountainLab",
    volume: 100
  },
  {
    image: '/img/capsules/supplements/multiLab-60.png',
    name: 'MultiLab',
    volume: 60
  },
  {
    image: '/img/capsules/supplements/ovalLab-40.png',
    name: "OvalLab",
    volume: 40
  },
  {
    image: '/img/capsules/supplements/fountainLab-200.png',
    name: "FountainLab",
    volume: 200
  },
  {
    image: '/img/capsules/supplements/ovalLab-80.png',
    name: "OvalLab",
    volume: 80
  }
]

const singleCell10 = {
    image: '/img/capsules/single-cell-10.png',

  //  name: 'Single cell',
  //  volume: 10
}
const singleCell20 = {
    image: '/img/capsules/single-cell-20.png',
  //  name: 'Single cell',
   // volume: 20
}
const singleCell40 = {
    image: '/img/capsules/single-cell-40.png',
 //   name: 'Single cell',
 //   volume: 40
}
const ovalSingleCell55 = {
    image: '/img/capsules/oval-single-cell-55.png',
  //  name: 'Oval single cell',
   // volume: 55
}
const ovalSingleCell80 = {
    image: '/img/capsules/oval-single-cell-80.png',
  //  name: 'Oval single cell',
  //  volume: 80
}
const ovalSingleCell100 = {
    image: '/img/capsules/oval-single-cell-100.png',
  //  name: 'Oval single cell',
  //  volume: 100
}
const ovalSingleCell120 = {
    image: '/img/capsules/oval-single-cell-120.png',
 //   name: 'Oval single cell',
  //  volume: 120
}
const multiCell20 = {
    image: '/img/capsules/multi-cell-20.png',
 //   name: 'Multi cell',
 //   volume: 20
}
const multiCell40 = {
    image: '/img/capsules/multi-cell-40.png',
  //  name: 'Multi cell',
  //  volume: 40
}
const multiCell60 = {
    image: '/img/capsules/multi-cell-60.png',
  //  name: 'Multi cell',
  //  volume: 60
}
const diya100 = {
    image: '/img/capsules/diya-100.png',
  //  name: 'Diya 2 capsule',
 //   volume: 100
}
const diya200 = {
    image: '/img/capsules/diya-200.png',
  //  name: 'Diya 2 capsule',
  //  volume: 200
}
const diya300 = {
    image: '/img/capsules/diya-300.png',
  //  name: 'Diya 2 capsule',
  //  volume: 300

}

export const USECASES = [
    {
        title: 'Skincare',
        value: 'beauty-skincare',
        path: '/use-cases/beauty-skincare',
        image: '/img/use-cases/beauty-skincare.png',
        video: '/img/use-cases/skincare.mp4',
        capsule: '/img/capsules/single-cell-20.png',
        subtitle: 'The CAPSULAB solution enables Skincare brands to deliver  an always personalized, always fresh product.',
        description: 'Skincare brands can deliver on an always personalized, always fresh offering.',
        items: {
            personalization: 'Products can be customized to the consumers personal needs on the spot.',
            activeIngredients: 'Potency can be maintained longer as the materials are preserved in vacuumed isolation until product manufacturing and use. In addition this enables to improve  overall product performance.',
            naturalClean: 'As the product is manufactured at point of use, the brand can minimize the use of stabilizing agents.'
        },
        capsules: skincare
    },
    {
        title: 'Color Cosmetics',
        subtitle: 'Using the CAPSULAB solution, beauty brands can provide their customers with real-time coloring and shades matching.',
        value: 'beauty-colorcosmetics',
        path: '/use-cases/beauty-colorcosmetics',
        image: '/img/use-cases/beauty-cosmetics.png',
        capsule: '/img/capsules/oval-single-cell-80.png',
        description: 'Beauty brands can deliver real-time coloring and shades optimization.',
        items: {
            personalization: 'Color products such as  Foundation, Tint and Gloss can be adjusted by the consumer to match to any skin type and undertone.',
            naturalClean: 'As the product is manufactured at point of use, the brand can minimize the use of stabilizing agents.'
        },
        capsules: color_cosmetics
    },
    {
        title: 'Hair Products',
        subtitle: 'Using the CAPSULAB solution, beauty brands can provide their customers with real-time coloring and shades matching.',
        value: 'beauty-hair',
        path: '/use-cases/beauty-hair',
        image: '/img/use-cases/beauty-hair.png',
        video: '/img/use-cases/haircolor.mp4',
        capsule: '/img/capsules/multi-cell-40.png',
        description: 'Hair brands can deliver real-time coloring and customizations.',
        items: {
            personalization: 'Hair products can be adjusted and customized by the consumer at the time of creation to match to any desired outcome. For example, in the case of hair color, one Capsule can provide the complete range of blonde shades.',
            activeIngredients: 'Potency can be maintained longer as the materials are preserved in vacuumed isolation until product manufacturing and use. In addition, this enables to improve overall product performance. ',
            naturalClean: 'As the product is manufactured at the point of use, the brand can minimize the use of stabilizing agents.'
        },
        capsules: hair
    },
    {
        title: 'Food',
        subtitle: 'Food brands can deliver on products that are manufactured at home - thus fresh and personalized to the taste of the consumer.',
        value: 'food-superfoods',
        path: '/use-cases/food-superfoods',
        image: '/img/use-cases/food-superfood.png',
        capsule: '/img/capsules/diya-200.png',
        description: 'Food brands can deliver on products that are manufactured at home - thus fresh and personalized to the taste of the consumer.',
        items: {
            personalization: 'Products can be customized to the consumer’s personal desired taste.',
            foodIngredients: 'Potency and distinct tastes can be maintained longer as the ingredients are preserved in vacuumed isolation until the product is manufactured and consumed.',
            naturalClean: 'As the product is manufactured at the point of use, the brand can minimize the use of preservatives.'
        },
        capsules: superfood
    },
    {
        title: 'Food Supplements',
        subtitle: 'Supplement brands using Capsulab’s Factory in a Capsule can provide their customers with personalized and higher potent products.',
        value: 'food-supplements',
        path: '/use-cases/food-supplements',
        image: '/img/use-cases/food-supplements.png',
        video: '/img/use-cases/supplements.mp4',
        capsule: '/img/capsules/diya-300.png',
        description: 'Supplement brands using Capsulab’s Factory in a Capsule can provide their customers with personalized and higher potent products.',
        items: {
            personalization: 'Supplement products can be adjusted and customized by the consumer at the time of creation to match the specific desired outcome.',
            activeIngredients: 'Potency can be maintained longer as the materials are preserved in vacuumed isolation until product manufacturing and use. In addition, this enables to improve overall product performance.',
            naturalClean: 'As the product is manufactured at the point of use, the brand can minimize the use of stabilizing agents'
        },
      capsules: supplements
    }
]
